module.exports = __webpack_public_path__ + "img/3f1e5e1.png";